exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ListIcon__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__ListIcon__root {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.DS__ListIcon__position_left {\n    margin-right: 12px;\n    color: #95a0b3;\n  }\n\n.DS__ListIcon__position_right {\n    margin-left: 12px;\n    color: #505f79;\n  }\n\n.DS__ListIcon__position_right-end {\n    margin-left: auto;\n    color: #505f79;\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__ListIcon__root",
	"position_left": "DS__ListIcon__position_left",
	"position_right": "DS__ListIcon__position_right",
	"position_right-end": "DS__ListIcon__position_right-end"
};